import { PropsWithChildren } from 'react';
import { BlockWrapper } from '../BlockWrapper/BlockWrapper';
import { useContentSelection, useOccasions, usePagination } from './hooks';
import { ApplicationMessage, OccasionsListing } from './components';
import { APPLICATION_CONFIG } from './config';
import type { ApplicationViewProps } from './types';

const Factory = (props: PropsWithChildren) => <>{props.children}</>;

const View = (props: ApplicationViewProps) => {
  // Content selection between props and Redux state
  const content = useContentSelection({ content: props.content });

  const data = { ...props.data };

  // Pagination logic with configurable page size
  const { maxItems, showMore } = usePagination(
    APPLICATION_CONFIG.DEFAULT_PAGE_SIZE,
  );

  // Occasions processing with custom hook
  const { occasions, hasMore } = useOccasions({
    content,
    maxItems,
    sortByFolderPosition: data.sort_by_folder_position,
  });

  const hasContent =
    occasions.length ||
    content?.application_infotext_inactive?.trim() ||
    content?.application_infotext_active?.trim() ||
    content?.application_note?.trim() ||
    data?.block_lead?.trim();

  if (!props?.isEdit && !hasContent && !data?.block_hide) {
    return null;
  }

  const hasOccasions = occasions.some(
    (o) => o?.actions?.[0]?.disabled !== true,
  );

  return (
    <BlockWrapper
      isEdit={props?.isEdit}
      block={props?.block}
      onChangeBlock={props?.onChangeBlock}
      data={data}
      factory={Factory}
    >
      <ApplicationMessage content={content} hasOccasions={hasOccasions} />
      <OccasionsListing
        occasions={occasions}
        hasMore={hasMore}
        onShowMore={showMore}
      />
    </BlockWrapper>
  );
};

export default View;
